import { render, staticRenderFns } from "./SetMfaPage.vue?vue&type=template&id=ae1cbe24&"
import script from "./SetMfaPage.ts?vue&type=script&lang=ts&"
export * from "./SetMfaPage.ts?vue&type=script&lang=ts&"
import style0 from "./SetMfaPage.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports